import { createAccountBaseRoute } from './baseAccountRoute'
import { sharedMarketingRoutes } from './sharedRoutes'
import { serviceDeskRoutes } from './serviceDeskRoutes'
import { commerceRoutes } from './commerceRoutes'
import { billingRoutes } from './billingRoutes'

export const marketingRoutesForServiceDesk = [
  createAccountBaseRoute('MarketingServiceDesk', [
    ...serviceDeskRoutes,
    ...sharedMarketingRoutes,
  ]),
]

export const marketingRoutesForCommerce = [
  createAccountBaseRoute('MarketingCommerce', [
    ...commerceRoutes,
    ...sharedMarketingRoutes,
  ]),
]

export const marketingRoutesForBilling = [
  createAccountBaseRoute('MarketingBilling', [
    ...billingRoutes,
  ]),
]